// extracted by mini-css-extract-plugin
module.exports = {"column":"ItemSmall-module--column--2I2AT","item":"ItemSmall-module--item--iGJsX"};